import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the FiltroAlmacenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-filtro-almacen',
  templateUrl: 'filtro-almacen.html',
})
export class FiltroAlmacenPage {
  almacenes: any = []
  almacenesres: any = []
  busqueda: any = ""
  valor: any
  police: boolean = false
  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.police = true;
    this.valor = this.navParams.get('value');
    this.almacenesres.push({
      co_alma: "TODOS",
      des_alma: "TODOS"
    });
    const vall = JSON.parse(window.localStorage.getItem('almacenes'));
    if (vall) this.almacenesres.push(...vall);
    this.almacenes = this.almacenesres.slice()
    setTimeout(() => {
      this.police = false;
    }, 100);
  }

  ionViewDidLoad() {
  }

  itemSelected(item) {
    if(!this.police && this.valor) this.viewCtrl.dismiss({value: item});
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }

  reset() {
    if (!this.busqueda) {
      this.almacenes = this.almacenesres.slice();
      this.police = true;
      this.valor = ""
      setTimeout(() => {
        this.valor = this.navParams.get('value');
      }, 100);
      setTimeout(() => {
        this.police = false;
      }, 110);
    }
  }

  buscar(){
    if (this.busqueda.trim() !== '') {
      this.police = true;
      this.valor = ""
      this.almacenes = this.almacenesres.filter((el) => {
        let arry = this.busqueda.split(' ')
        if (arry.length === 1) {
          return el.co_alma.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1 ||
            el.des_alma.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1
        } else {
          let cont = 0
          let cont2 = 0
          for (let i = 0; i < arry.length; i++) {
            if (el.co_alma.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
              cont++
            }
            if (el.des_alma.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
              cont2++
            }
            el.puntuacion = (cont > cont2) ? cont : cont2
          }
          if (cont > 0 || cont2 > 0) {
            return el
          }
        }
      })
      this.almacenes.sort(function(a, b) {
        return b.puntuacion - a.puntuacion;
      });
      setTimeout(() => {
        this.valor = this.navParams.get('actual');
      }, 100);
      setTimeout(() => {
        this.police = false;
      }, 110);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/filtro-almacen/filtro-almacen.ts